module.exports = __webpack_public_path__ + "static/img/choose5.b0ff3da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/choose5.png
// module id = Cado
// module chunks = 8